<template>
  <v-app-bar fixed light app height="60">
    <div class="page-title flex-grow-1">
      {{
        $helpers.translateKeyContent(
          "QoalaExternalDashboardGadget",
          pageInfo.pageTitle,
        )
      }}
    </div>

    <!-- notification -->
    <!-- <v-menu
      :nudge-bottom="14"
      attach
      left
      offset-y
    >
      <template v-slot:activator="{ on }">
        <v-btn
          icon
          text
          v-on="on"
        >
          <v-badge
            color="red"
            overlap
          >
            <span slot="badge">
              3
            </span>
            <v-icon medium>
              notifications
            </v-icon>
          </v-badge>
        </v-btn>
      </template>
      <notification-list />
    </v-menu> -->

    <!-- profile -->
    <v-menu :nudge-bottom="10" attach left offset-y min-width="218">
      <template v-slot:activator="{ on }">
        <v-btn icon text color="#fff" v-on="on">
          <v-icon size="24">{{ mdiAccount }}</v-icon>
        </v-btn>
      </template>

      <app-menu-profile
        :items-language="itemsLanguage"
        @toggle-modal-logout-desktop="$emit('toggle-modal-logout-desktop')"
        @language-changed="$emit('language-changed', $event)"
      ></app-menu-profile>
    </v-menu>
  </v-app-bar>
</template>

<script>
import { mdiAccount } from "@mdi/js";
import { get } from "lodash-es";

import AppMenuProfile from "@/components/AppMenuProfile";

export default {
  name: "AppToolbar",

  components: {
    AppMenuProfile,
  },

  props: {
    itemsLanguage: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      mdiAccount,
    };
  },

  computed: {
    pageInfo() {
      return get(this.$store, 'getters["app/getPageInfo"]', {});
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep.v-toolbar {
  box-shadow: none;
  z-index: 99;

  .v-toolbar__content {
    height: 100% !important;
    padding: 0 24px;
  }

  &.theme--light.v-app-bar.v-sheet {
    background-color: var(--bg);
  }
}

.page-title {
  font-size: 20px;
  font-weight: bold;
  color: #fff;
}
</style>
